import React from 'react';
import { selectedElement } from 'features/document/documentSlice';
import { ElementType } from 'features/document/constants';
import CheckboxSidebar from './components/CheckboxSidebar/CheckboxSidebar';
import DateSidebar from './components/DateSidebar/DateSidebar';
import DividerSidebar from './components/DividerSidebar/DividerSidebar';
import DropdownSidebar from './components/DropdownSidebar/DropdownSidebar';
import ImageSidebar from './components/ImageSidebar/ImageSidebar';
import RadioButtonSidebar from './components/RadioButtonSidebar/RadioButtonSidebar';
import SignatureSidebar from './components/SignatureSidebar/SignatureSidebar';
import TextFieldSidebar from './components/TextFieldSidebar/TextFieldSidebar';
import VideoSidebar from './components/VideoSidebar/VideoSidebar';
import InitialsSidebar from './components/InitialsSidebar/InitialsSidebar';
import TableSidebar from './components/TableSidebar/TableSidebar';
import SpacerSidebar from './components/SpacerSidebar/SpacerSidebar';
import PricingTableSidebar from './components/PricingTableSidebar/PricingTableSidebar';
import BillToSidebar from './components/BillToSidebar/BillToSidebar';
import ShipToSidebar from './components/ShipToSidebar/ShipToSidebar';
import ContactInfoSidebar from './components/ContactInfoSidebar/ContactInfoSidebar';
import QuoteAcceptanceInfoTableSidebar from './components/QuoteAcceptanceInfoTableSidebar/QuoteAcceptanceInfoTableSidebar';
import ContractInfoSidebar from './components/ContractInfoSidebar/ContractInfoSidebar';
import ApprovalSidebar from './components/ApprovalSidebar/ApprovalSidebar';
import TextSidebar from './components/TextSidebar/TextSidebar';

interface Props {
  selectedItem: selectedElement;
}

const SidebarElementFactory: React.FC<Props> = ({ selectedItem }) => {
  const {
    data: { type },
  } = selectedItem;

  if (type === ElementType.CheckBox && selectedItem) {
    return <CheckboxSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.Date && selectedItem) {
    return <DateSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.Dropdown && selectedItem) {
    return <DropdownSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.Divider && selectedItem) {
    return <DividerSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.Image && selectedItem) {
    return <ImageSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.RadioButton && selectedItem) {
    return <RadioButtonSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.TextField && selectedItem) {
    return <TextFieldSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.Video && selectedItem) {
    return <VideoSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.Signature && selectedItem) {
    return <SignatureSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.Initials && selectedItem) {
    return <InitialsSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.Table && selectedItem) {
    return <TableSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.Spacer && selectedItem) {
    return <SpacerSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.PricingTable && selectedItem) {
    return <PricingTableSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.BillTo && selectedItem) {
    return <BillToSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.ShipTo && selectedItem) {
    return <ShipToSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.ContactInfo && selectedItem) {
    return <ContactInfoSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.QuoteAcceptanceInfoTable && selectedItem) {
    return <QuoteAcceptanceInfoTableSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.ContractInfoTable && selectedItem) {
    return <ContractInfoSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.ApprovalTable && selectedItem) {
    return <ApprovalSidebar currentElement={selectedItem} />;
  }
  if (type === ElementType.Text && selectedItem) {
    return <TextSidebar currentElement={selectedItem} />;
  }
  return null;
};

export default SidebarElementFactory;
